import React from 'react';
import X from '../../assets/icons/new_icon/x.svg';

interface Props {
  onClose: any;
  onSuccess: any;
  title?: string;
  description?: string;
  confirmTitle?: any;
  size?: any;
  variant?: any;
}
const AlertModal = ({
  onClose,
  onSuccess,
  title,
  description,
  confirmTitle,
  size,
  variant,
}: Props) => {
  const handleClose = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className='modal'
      id='add_leg_document_modal'
      style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5) ' }}
      tabIndex={-1}
      aria-labelledby='add_leg_document_modal_label'
      aria-hidden='true'
      onClick={handleClose}
    >
      <div className={`modal-dialog ${size ? size : 'modal-md'}`}>
        <div className='modal-content' style={{ borderRadius: '8px' }}>
          <div className='modal-header d-flex w-100 justify-content-between px-4 py-2 align-items-center'>
            <h3 className='newubbemodalheading mb-0'>
              {title ? title : ' Confirm Deletion'}
            </h3>
            <img
              src={X}
              onClick={() => onClose()}
              style={{ cursor: 'pointer' }}
              alt=''
            />
          </div>
          <div className='modal-body mt-2 mb-0'>
            <p className=' disable_discription mb-0'>{description}</p>
          </div>
          <div className='pb-2'>
            <p
              className={`btn  p-2 px-4 w-100 rounded-3 text-light d-flex m-auto justify-content-center align-items-center mb-2 btn btn-ubbe-new-blue ${
                variant && variant === 'success' ? 'bg-main' : 'bg-danger-red'
              }`}
              style={{
                maxWidth: 'max-content',
                height: '48px',
                // backgroundColor:
                //   variant && variant === 'success' ? '#FC0000' : '#251163',
                fontSize: '18px',
              }}
              onClick={() => onSuccess()}
            >
              {confirmTitle ? confirmTitle : 'Cancel Pickup'}
            </p>
            <u
              className='m-auto d-flex justify-content-center labelText mb-1 mt-2'
              style={{ cursor: 'pointer' }}
              aria-label='Close'
              onClick={() => onClose()}
            >
              Cancel
            </u>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;
